<template>
  <div class="animated fadeIn presupuestos-internos">
    <b-row>
      <b-col cols="12">
        <b-form>
          <b-card header= "Información del Presupuesto" class="presupuesto-header">
            <b-btn class="btn-collapse-card" 
                variant="primary" 
                size="sm"
                @click.prevent="showHeader= !showHeader">
              <i :class="showHeader ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
            </b-btn>
            <b-collapse id="header" class="mt-2" v-model="showHeader">
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="Nro. PI"
                    label-for="presupuestoNumero"
                    :labelCols="labelCols"
                    v-if="presupuestoNumero != ''"
                    horizontal>
                    <b-form-input 
                      id="presupuestoNumero"
                      :value="presupuestoNumero"
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Cliente"
                    label-for="cliente"
                    :label-cols="2"
                    horizontal>
                    <b-input-group>
                      <b-input-group-append 
                          class="filter-search-icons" 
                          @click="seleccionarCliente"
                          v-if="!confirmado & !isAdicional">
                        <b-input-group-text>
                          <i :class="{ 'fa fa-search': !cliente,
                                        'fa fa-remove': cliente  }"></i>
                        </b-input-group-text>
                      </b-input-group-append>
                      <b-form-input 
                        id="cliente"
                        :value="clienteNombre"
                        readonly
                        :state="clienteValido"
                        type="text"/>
                      <b-form-invalid-feedback id="clienteFeedback">
                        {{ clienteInvalidoMsj }}
                      </b-form-invalid-feedback>          
                    </b-input-group>
                  </b-form-group>

                  <b-form-group
                    label="Acción"
                    label-for="accion"
                    :labelCols="labelCols"
                    horizontal>
                    <b-form-input 
                      id="accion"
                      v-model.trim="$v.accion.$model" 
                      :state="accionValida"
                      type="text"
                      @blur.native="validate"
                      :readOnly="confirmado || isAdicional">
                    </b-form-input>
                    <b-form-invalid-feedback id="accionFeedback">
                      {{ accionInvalidaMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-form-group
                    label="Contacto"
                    label-for="clienteContacto"
                    :label-cols="labelCols"
                    horizontal>
                    <b-input-group>
                      <b-input-group-append
                          v-if="!isAdicional && clienteId != 0" 
                          class="filter-search-icons" 
                          @click="seleccionarClienteContacto">
                        <b-input-group-text>
                          <i :class="{ 'fa fa-search': !clienteContacto,
                                        'fa fa-remove': clienteContacto  }"></i>
                        </b-input-group-text>
                      </b-input-group-append>
                      <b-input-group-append 
                          v-if="!isAdicional && clienteId != 0 && clienteContactoId == 0" 
                          class="filter-search-icons" 
                          @click="addContacto">
                        <b-input-group-text>
                          <i class="fa fa-plus" aria-hidden="true"></i>
                        </b-input-group-text>
                      </b-input-group-append>
                      <b-form-input 
                        id="clienteContacto"
                        :value="clienteContactoNombre"
                        readonly
                        :state="clienteContactoValido"
                        type="text"/>
                      <b-form-invalid-feedback id="clienteContactoFeedback">
                        {{ clienteContactoInvalidoMsj }}
                      </b-form-invalid-feedback>          
                    </b-input-group>
                  </b-form-group>

                  <app-tipo-presupuesto
                    label="Tipo"
                    :nombre="tipoPresupuestoNombre"
                    :labelCols="labelCols"
                    labelOption="Seleccione un tipo de presupuesto"
                    :valido="tipoPresupuestoValido"
                    :lista="tiposPresupuestosList"
                    :msjInvalido="tipoPresupuestoInvalidoMsj"
                    @validate="validate"
                    @updated="tipoPresupuestoActualizado">
                  </app-tipo-presupuesto>

                  <b-form-group
                    label="Nro.Orden"
                    label-for="numeroOrdenCompra"
                    description="Número de orden de compra"
                    :labelCols="labelCols"
                    horizontal>
                    <b-form-input 
                      id="numeroOrdenCompra"
                      v-model.trim="$v.numeroOrdenCompra.$model" 
                      :state="numeroOrdenCompraValida"
                      type="text"
                      @blur.native="validate"
                      :readOnly="isAdicional">
                      <!--:readOnly="confirmado">-->
                    </b-form-input>
                    <b-form-invalid-feedback id="numeroOrdenCompraFeedback">
                      {{ numeroOrdenCompraInvalidaMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-form-group
                    label="Fecha Orden"
                    label-for="fechaOrdenCompra"
                    description="Fecha de orden de compra"
                    :label-cols="labelCols">
                    <b-input-group>
                      <b-input-group-prepend is-text>
                        <b-form-checkbox 
                            id="fechaOrdenCompraHabilitada"
                            v-model="fechaOrdenCompraHabilitada"
                            value= true
                            unchecked-value= false>
                        </b-form-checkbox>
                      </b-input-group-prepend>
                      <b-form-input 
                        id="fechaOrdenCompra" 
                        v-model="fechaOrdenCompra" 
                        type="date"
                        :disabled="fechaOrdenCompraDisabled"
                        :state="fechaOrdenCompraValida"
                        @blur.native="validate">
                      </b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback id="fechaOrdenCompraFeedback">
                      {{ fechaOrdenCompraInvalidaMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-form-group
                    label="Descripción"
                    label-for="descripcionOrdenCompra"
                    description="Descripción de la orden de compra"
                    :labelCols="labelCols"
                    horizontal>
                    <b-form-input 
                      id="descripcionOrdenCompra"
                      v-model.trim="$v.descripcionOrdenCompra.$model" 
                      :state="descripcionOrdenCompraValida"
                      type="text"
                      @blur.native="validate"
                      :readOnly="isAdicional">
                    </b-form-input>
                    <b-form-invalid-feedback id="descripcionOrdenCompraFeedback">
                      {{ descripcionOrdenCompraInvalidaMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="6">
                  <b-form-group
                    label="Fecha de Entrega"
                    label-for="fechaEntrega"
                    :labelCols="labelCols * 2">
                    <b-input-group>
                      <b-form-input 
                        id="fechaEntrega" 
                        v-model="fechaEntrega" 
                        type="date"
                        :state="fechaEntregaValida"
                        @blur.native="validate"
                        :readOnly="isAdicional">
                      </b-form-input>
                    </b-input-group>
                    <b-form-invalid-feedback id="fechaEntregaFeedback">
                      {{ fechaEntregaInvalidaMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <app-prioridad
                    v-if="!isAdicional"
                    label="Prioridad"
                    :nombre="prioridadNombre"
                    :labelCols="labelCols * 2"
                    :valido="prioridadValida"
                    :lista="prioridadesList"
                    :msjInvalido="prioridadInvalidaMsj"
                    @validate="validate"
                    @updated="prioridadActualizada">
                  </app-prioridad>  

                  <b-form-group
                    v-if="isAdicional"
                    label="Prioridad"
                    label-for="prioridadNombre"
                    :labelCols="labelCols * 2"
                    horizontal>
                    <b-form-input 
                      id="prioridadNombre"
                      :value="prioridadNombre" 
                      type="text"
                      readOnly>
                    </b-form-input>
                  </b-form-group>

                  <app-moneda
                    v-if="!isAdicional & !confirmado"
                    label="Moneda"
                    :nombre="monedaNombre"
                    :labelCols="labelCols * 2"
                    :valido="monedaValida"
                    :lista="monedasList"
                    :msjInvalido="monedaInvalidaMsj"
                    @validate="validate"
                    @updated="monedaActualizada">
                  </app-moneda>  

                  <b-form-group
                    v-if="isAdicional | confirmado"
                    label="Moneda"
                    label-for="monedaNombre"
                    :labelCols="labelCols * 2"
                    horizontal>
                    <b-form-input 
                      id="monedaNombre"
                      :value="monedaNombre" 
                      type="text"
                      readOnly>
                    </b-form-input>
                  </b-form-group>
                  
                  <b-form-group
                    label="Cotización USD"
                    label-for="monedaCotizacion"
                    :labelCols="labelCols * 2"
                    description="Cotización de referencia"
                    horizontal>
                    <b-form-input 
                      id="monedaCotizacion"
                      v-model.trim="$v.monedaCotizacion.$model" 
                      :state="monedaCotizacionValida"
                      type="text"
                      :readonly="!isCotizacionMonedaEditable"
                      @blur.native="validate">
                    </b-form-input>
                    <b-form-invalid-feedback id="monedaCotizacionFeedback">
                      {{ monedaCotizacionInvalidaMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-form-group
                    label="Fee Agencia"
                    label-for="feeAgencia"
                    :labelCols="labelCols * 2"
                    :description="descripcionFee"
                    horizontal>
                    <b-input-group>
                      <b-form-input 
                        id="feeAgencia"
                        v-model.trim="$v.feeAgencia.$model" 
                        :state="feeAgenciaValido"
                        type="text"
                        :readonly="confirmado || isAdicional || aplicarEscalaFee"
                        @blur.native="validate">
                      </b-form-input>
                      <b-input-group-append 
                          class="filter-search-icons" 
                          @click="consultarEscalasFee"
                          v-if="aplicarEscalaFee">
                        <b-input-group-text>
                          <i class="fa fa-info"></i>
                        </b-input-group-text>
                      </b-input-group-append>
                      <b-form-invalid-feedback id="feeAgenciaFeedback">
                        {{ feeAgenciaInvalidoMsj }}
                      </b-form-invalid-feedback>          
                    </b-input-group>
                  </b-form-group>

                  <b-form-group
                    label="Fee Diferenciado"
                    label-for="feeAgenciaPremios"
                    :labelCols="labelCols * 2"
                    horizontal
                    description="Fee de Agencia de Rubros Diferenciados"
                    v-if="discriminarFeePremios">
                    <b-form-input 
                      id="feeAgenciaPremios"
                      v-model.trim="$v.feeAgenciaPremios.$model" 
                      :state="feeAgenciaPremiosValido"
                      type="text"
                      :readonly="confirmado || isAdicional"
                      @blur.native="validate">
                    </b-form-input>
                    <b-form-invalid-feedback id="feeAgenciaPremiosFeedback">
                      {{ feeAgenciaPremiosInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-form-group
                    label="Pje Financiación"
                    label-for="pjeFinanciacion"
                    :labelCols="labelCols * 2"
                    :description="descripcionFinanciacion"
                    horizontal>
                    <b-input-group>
                      <b-form-input 
                        id="pjeFinanciacion"
                        v-model.trim="$v.pjeFinanciacion.$model" 
                        :state="pjeFinanciacionValido"
                        type="text"
                        :readonly="confirmado || isAdicional || aplicarEscalaFinanciacion"
                        @blur.native="validate">
                      </b-form-input>
                      <b-input-group-append 
                          class="filter-search-icons" 
                          @click="consultarEscalasFinanciacion"
                          v-if="aplicarEscalaFinanciacion">
                        <b-input-group-text>
                          <i class="fa fa-info"></i>
                        </b-input-group-text>
                      </b-input-group-append>
                    </b-input-group>
                    <b-form-invalid-feedback id="pjeFinanciacionFeedback">
                      {{ pjeFinanciacionInvalidoMsj }}
                    </b-form-invalid-feedback>          
                  </b-form-group>

                  <b-form-group
                    label="Pje Recargo"
                    label-for="pjeRecargoServicioPropio"
                    :label-cols="labelCols * 2"
                    description="Pje de Recargo sobre trabajos de servicio propio"
                    v-if="pjeRecargoServicioPropio != 0"
                    horizontal>
                    <b-form-input 
                      id="pjeRecargoServicioPropio"
                      :value="pjeRecargoServicioPropio | porcentaje" 
                      readonly
                      type="text">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    :label-cols="labelCols * 2"
                    horizontal>
                    <b-form-checkbox 
                        id="causaSocial"
                        v-model="causaSocial"
                        value= true
                        unchecked-value= false
                        :disabled="isAdicional">
                        Causa Social
                    </b-form-checkbox>
                  </b-form-group>

                  <b-form-group
                    :label-cols="labelCols * 2"
                    horizontal>
                    <b-form-checkbox 
                        id="causaAmbiental"
                        v-model="causaAmbiental"
                        value= true
                        unchecked-value= false
                        :disabled="isAdicional">
                        Causa Ambiental
                    </b-form-checkbox>
                  </b-form-group>

                  <b-form-group
                    :label-cols="labelCols * 2"
                    horizontal>
                    <b-form-checkbox 
                        id="propuestaAgencia"
                        v-model="propuestaAgencia"
                        :value="true"
                        :unchecked-value="false"
                        :disabled="isAdicional">
                        Propuesta de la Agencia
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>

          <app-usuarios-propuesta ref="usuariosPropuesta" v-if="propuestaAgencia"/>

          <app-usuarios ref="usuarios"/>

          <b-card header= "Provincias" class="presupuesto-header" v-if="seleccionProvincias">
            <b-btn class="btn-collapse-card" 
                variant="primary" 
                size="sm"
                @click.prevent="showProvincias= !showProvincias">
              <i :class="showProvincias ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
            </b-btn>
            <b-collapse id="headerProvincias" class="mt-2" v-model="showProvincias">
              <b-row>
                <b-col>
                  <b-table hover
                      responsive="sm" 
                      class="registro"
                      :items="provincias" 
                      :fields="provinciasFields">
                    <template v-slot:cell(seleccionada)="data">
                      <b-form-checkbox
                          v-model="data.item.seleccionada"
                          :disabled="isCertificado"
                          :value="Boolean(true)"
                          :unchecked-value="Boolean(false)">
                      </b-form-checkbox> 
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>

          <app-renglones
            ref="renglones"
            :accesoImagenes="accesoImagenes"
            :accesoAlternativas="accesoAlternativas"
            :accesoDescuentoOrden="accesoDescuentoOrden"
            @editarOrden="editarOrden"
            @editarDescuentoOrden="editarDescuentoOrden"
            @agregarOrdenAlternativa="agregarOrdenAlternativa"
            @consultarAlternativas="consultarAlternativas">
          </app-renglones>

          <app-alternativas
            ref="alternativas"
            v-if="consultaAlternativas"
            :accesoImagenes="accesoImagenes"
            @agregarOrdenAlternativa="agregarOrdenAlternativa"
            @editarAlternativa="editarAlternativa"
            @seleccionarAlternativa="seleccionarAlternativa"
            @closeAlternativas="closeAlternativas">
          </app-alternativas>

          <app-comisiones
            v-if="accesoComisiones"
            ref="comisiones"
            :isAdicional="isAdicional"
            @agregarComision="agregarComision"
            @editarComision="editarComision"
            @borrarComision="borrarComision">
          </app-comisiones>

          <app-facturacion
            ref="facturacion"
            v-if="accesoFacturacion"
            @addFechaFacturacion="addFechaFacturacion"
            @editFechaFacturacion="editFechaFacturacion"
            @removeFechaFacturacion="removeFechaFacturacion">
          </app-facturacion>

          <app-totales
            ref="totales"
            :confirmado="confirmado"
            :isAdicional="isAdicional"
            :accesoDescuento="accesoDescuento"
            :accesoDescuentoRebate="accesoDescuentoRebate">
          </app-totales>
        </b-form>
      </b-col>
    </b-row>
    
    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>

    <b-modal title="SGC"
        header-bg-variant= "light" 
        hide-header-close
        v-model="confirmSalirModalVisible">
        ¿Desea abandonar el presupuesto sin guardar la información?
      <div slot="modal-footer">
        <b-button size="sm" variant="success" class="footer-button"
          @click.prevent="guardarSalir">Guardar y salir</b-button>
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="leave">Salir sin guardar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="cancelarSalir">Cancelar</b-button>
      </div>      
    </b-modal>  

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <b-modal ref="searchClienteContactoModal" 
        title="Seleccionar Contacto"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente-contacto
        :cliente="cliente"
        @contactoSeleccionado="clienteContactoSeleccionado">
      </app-search-cliente-contacto>  
    </b-modal>

    <b-modal ref="contactoModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM">
      <app-alta-contacto
        :cliente="cliente"
        :modal="Boolean(true)" 
        @updateContactos="updateContactos"
        @closeContacto="closeContacto">
      </app-alta-contacto>  
    </b-modal>

    <b-modal ref="ordenTrabajoModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalOrdenTrabajo">
      <app-orden-trabajo
        :altaOrden="Boolean(altaOrden)"
        @updateOrdenes="updateOrdenes"
        @closeOrden="closeOrden">
      </app-orden-trabajo>  
    </b-modal>

    <b-modal ref="ordenTrabajoAlternativaModal"
        hide-header
        hide-footer
        lazy
        modal-class="modalABM modalOrdenTrabajo">
      <app-orden-trabajo-alternativa
        :altaOrden="Boolean(altaOrden)"
        @closeOrdenAlternativa="closeOrdenAlternativa">
      </app-orden-trabajo-alternativa>  
    </b-modal>

    <b-modal ref="facturacionModal"
        title="Facturación Estimada"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-presupuesto-facturacion
        :facturacion="facturacionSeleccionada"
        @close="closePresupuestoFacturacion">
      </app-presupuesto-facturacion>  
    </b-modal>

    <b-modal ref="vendedorComisionModal"
        title="Comisión Vendedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-vendedor-comision
        :vendedorComision="vendedorComision"
        :montoBaseComision="montoBaseComision"
        :pjeComisionInternaComercial="pjeComisionInterna"
        :monedaId="monedaId"
        @close="closeVendedorComision">
      </app-vendedor-comision>  
    </b-modal>

    <b-modal ref="edicionDescuentoOrdenModal" 
        title="Editar Descuento"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-importe-descuento
        :params="paramsActualizacion"
        @save="actualizarDescuentoOrden"
        @close="closeActualizacionDescuentoOrden">
      </app-importe-descuento>  
    </b-modal>

    <b-modal ref="escalasFeeModal"
        title="Escalas Fee"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-escalas-fee
        :escalasFee="escalasFee">
      </app-escalas-fee>
    </b-modal>

    <b-modal ref="escalasFinanciacionModal"
        title="Escalas Financiacion"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-escalas-financiacion
        :escalasFinanciacion="escalasFinanciacion">
      </app-escalas-financiacion>
    </b-modal>

    <app-botones
      :agregarHabilitado="Boolean(true)"
      @save="save"
      @cancel="cancelar"
      @agregar="agregarOrden">
    </app-botones>  
  </div>
</template>

<script>
import { required, decimal, minValue, maxValue, maxLength } from 'vuelidate/lib/validators';
import SearchCliente from '../clientes/SearchList.vue';
import SearchClienteContacto from '../clientescontactos/SearchList.vue';
import TipoPresupuesto from '../shared/abmSelect.vue';
import Prioridad from '../shared/abmSelect.vue';
import Moneda from '../shared/abmSelect.vue';
import abmButtonsPresupuestosInternos from '../shared/abmButtonsPresupuestosInternos.vue';
import AltaContacto from '../clientescontactos/ABM.vue';
import Usuarios from './Usuarios.vue';
import UsuariosPropuesta from './UsuariosPropuesta.vue';
import Renglones from './Renglones.vue';
import Facturacion from './Facturacion.vue';
import Comisiones from './Comisiones.vue';
import Totales from './Totales.vue';
import Alternativas from './Alternativas.vue';
import OrdenTrabajo from '../ordenestrabajos/ABM';
import OrdenTrabajoAlternativa from '../ordenestrabajos/Alternativa';
import PresupuestoFacturacion from './PresupuestoFacturacion';
import VendedorComision from './VendedorComision';
import ImporteDescuento from '../shared/importeModal.vue';
import EscalasFee from './EscalasFee';
import EscalasFinanciacion from './EscalasFinanciacion';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';

import { mapState } from 'vuex';

import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'presupuestointerno/getField',
  mutationType: 'presupuestointerno/updateField',
});

export default {
  name: 'ABM',
  components: {
    appSearchCliente: SearchCliente,
    appSearchClienteContacto: SearchClienteContacto,
    appTipoPresupuesto: TipoPresupuesto,
    appPrioridad: Prioridad,
    appMoneda: Moneda,
    appBotones: abmButtonsPresupuestosInternos,
    appAltaContacto: AltaContacto,
    appUsuarios: Usuarios,
    appUsuariosPropuesta: UsuariosPropuesta,
    appRenglones: Renglones,
    appFacturacion: Facturacion,
    appComisiones: Comisiones,
    appTotales: Totales,
    appAlternativas: Alternativas,
    appOrdenTrabajo: OrdenTrabajo,
    appOrdenTrabajoAlternativa: OrdenTrabajoAlternativa,
    appPresupuestoFacturacion: PresupuestoFacturacion,
    appVendedorComision: VendedorComision,
    appImporteDescuento: ImporteDescuento,
    appEscalasFee: EscalasFee,
    appEscalasFinanciacion: EscalasFinanciacion,
    appMensaje: Mensaje,
    appConfirm: Confirm
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data () {
    return {
      saving: false,

      confirmSalirModalVisible: false,

      noValidar: true,
      clienteValido: null,
      clienteInvalidoMsj: '',
      accionValida: null,
      accionInvalidaMsj: '',
      clienteContactoValido: null,
      clienteContactoInvalidoMsj: '',
      tipoPresupuestoValido: null,
      tipoPresupuestoInvalidoMsj: '',
      prioridadValida: null,
      prioridadInvalidaMsj: '',
      monedaValida: null,
      monedaInvalidaMsj: '',
      monedaCotizacionValida: null,
      monedaCotizacionInvalidaMsj: '',
      fechaEntregaValida: null,
      fechaEntregaInvalidaMsj: '',
      numeroOrdenCompraValida: null,
      numeroOrdenCompraInvalidaMsj: '',
      fechaOrdenCompraValida: null,
      fechaOrdenCompraInvalidaMsj: '',
      descripcionOrdenCompraValida: null,
      descripcionOrdenCompraInvalidaMsj: '',
      feeAgenciaValido: null,
      feeAgenciaInvalidoMsj: '',
      feeAgenciaPremiosValido: null,
      feeAgenciaPremiosInvalidoMsj: '',
      pjeFinanciacionValido: null,
      pjeFinanciacionInvalidoMsj: '',
      fechaOrdenCompraDisabled: true,

      clientes: [],
      clientesList: [],
      // clientesContactos: [],
      // clientesContactosList: [],
      tiposPresupuestos: [],
      tiposPresupuestosList: [],
      prioridades: [],
      prioridadesList: [],
      monedas: [],
      monedasList: [],

      provinciasFields: [
        { key: 'provincia' },
        {
          key: 'seleccionada',
          label: '',
          class: 'text-center'
        },
      ],

      // ordenSeleccionada: null,
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      altaOrden: false,
      
      /* Edición del descuento a nivel de orden */
      ordenTrabajoId: 0,
      paramsActualizacion: null, 

      facturacionSeleccionada: null,
      vendedorComision: null,

      showHeader: true,
      showProvincias: false,
      // showTotales: true,

      labelCols: 2,
      saved: false,
      cancelled: false,
      routeNext: null,

      inicializandoMonedas: false,
      inicializandoPrioridades: false,
      inicializandoTiposPresupuestos: false,

      accesoImagenes: false,
      accesoAlternativas: true,
      accesoDescuento: false,
      // accesoComisiones: false,
      accesoDescuentoRebate: false,
      accesoDescuentoOrden: false,
      accesoEdicionCotizacion: false,
      accesoFacturacion: false
    }
  },
  computed: {
    ...mapFields([
      'id',
      'presupuestoInternoInicialId',
      'fechaEntrega',
      'tipoPresupuesto',
      'tipoPresupuestoNombre',
      'presupuestoNumero',
      // 'numero',
      // 'adicionalNumero',
      'clienteId',
      'cliente',
      'clienteNombre',
      'condicionFiscalId',
      'accion',
      'clienteContactoId',
      'clienteContacto',
      'clienteContactoNombre',
      'numeroOrdenCompra',
      'fechaOrdenCompra',
      'fechaOrdenCompraHabilitada',
      'descripcionOrdenCompra',
      'prioridadId',
      'prioridad',
      'prioridadNombre',
      'monedaId',
      'moneda',
      'monedaNombre',
      'monedaCotizacion',
      'feeAgencia',
      'aplicarEscalaFee',
      'escalasFee',
      'feeAgenciaPremios',
      'discriminarFeePremios',

      'pjeFinanciacion',
      'aplicarEscalaFinanciacion',
      'feeSobreFinanciacion',
      'escalasFinanciacion',

      'reembolsos',
      'discriminarCategoriaServicio',
      'pjeRecargoServicioPropio',
      
      // 'ordenesTrabajos',
      'ordenTrabajoAlternativas',
      'alternativasDatos',

      'confirmado',
      'causaSocial',
      'causaAmbiental',
      'seleccionProvincias',
      'propuestaAgencia',

      'provincias',

      'montoCertificado',

      'accesoComisiones',
      // 'vendedorComision',
      'montoBaseComision',
      'pjeComisionInterna',
    ]),
    ...mapState({
      presupuestando: state => state.presupuestointernoprocess.presupuestando,
      presupuestoInternoId: state => state.presupuestointernoprocess.presupuestoInternoId,
    }),
    isAdicional() {
      if (this.presupuestoInternoInicialId) {
        if (this.presupuestoInternoInicialId != 0) {
          return true;
        }
      }
      return false;
    },
    monedaSimbolo() {
      if (this.monedaId) {
        if (this.monedaId == 102) {  
          return 'usd';
        }
      }
      return '$';
    },
    consultaAlternativas() {
      if (this.alternativasDatos) {
        if (this.alternativasDatos.length != 0) {
          return true;
        }
      }
      return false;
    },
    isCertificado() {
      if (this.montoCertificado) {
        if (this.montoCertificado != 0) {
          return true;
        }
      }
      return false;
    },
    isCotizacionMonedaEditable() {
      if (this.isAdicional) {
        return false;
      }
      if (!this.confirmado) {
        return true;
      }
      /* Validamos si es Cervetti Chile o si tiene acceso */
      return this.clienteId == 83 || this.accesoEdicionCotizacion;
    },
    descripcionFee() {
      if (this.aplicarEscalaFee) {
        return 'Aplica escala de porcentajes';
      }

      return null;
    },
    descripcionFinanciacion() {
      if (this.aplicarEscalaFinanciacion) {
        return 'Aplica escala de porcentajes';
      }

      return null;
    },
  },  
  created() {
    let presupuestoId = 0;
    let presupuestoInicialId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        presupuestoId = this.$route.params.id;
      }
      if (this.$route.params.presupuestoInicialId){
        /* Parámetro el presupuesto interno inicial */
        presupuestoInicialId = this.$route.params.presupuestoInicialId;
      }
    }

    let inicializar = false;
    if (this.presupuestando) {
      if (presupuestoId != this.presupuestoInternoId) {
        inicializar = true;
      } else {
        inicializar = false;
      }
    } else {
      inicializar = true;
    }

    if (inicializar) {
      this.getDatosAdicionales();

      this.$store.dispatch('presupuestointernoprocess/InicializarPresupuestacion', presupuestoId)
        .then (() => {
          let params = {
            presupuestoId,
            presupuestoInicialId
          }
          // console.log(this.isAdicional);

          this.showSpinner();
          this.$store.dispatch('presupuestointerno/inicializar', params)
            .then(() => {
              if (moment(this.fechaOrdenCompra).format('YYYY-MM-DD') == '1900-01-01') {
                this.fechaOrdenCompraDisabled = true;
              } else {
                this.fechaOrdenCompraDisabled = false;
              }
            
              // this.loadingContactos = true;
              // this.getContactos(true);
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner())
        })
    // } else {
    //   this.getContactos();
    }

    this.accesoImagenes = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosImagenes'));
    this.accesoDescuento = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosDescuentoGeneral'));
    this.accesoDescuentoRebate = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosDescuentoRebate'));
    this.accesoDescuentoOrden = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosDescuentoOrdenes'));
    this.accesoEdicionCotizacion = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosEditarCotizacionCertificados'));
    this.accesoFacturacion = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosFacturacionEstimada'));
  },
  destroyed() {
    if (this.saved || this.cancelled) {
      this.$store.dispatch('presupuestointernoprocess/FinalizarPresupuestacion')
        .then (() => {
          this.$store.dispatch('presupuestointerno/inicializar');
          this.$store.dispatch('ordentrabajo/inicializar');
        })
        .catch(error => this.showErrorMsj(error));
    }
  },
  methods: {
    getDatosAdicionales() {
      let vm = this;

      vm.inicializandoTiposPresupuestos = true;
      vm.$store.dispatch('tiposPresupuestos/getList')
        .then(() => {
          vm.tiposPresupuestos = this.$store.getters['tiposPresupuestos/list'];
          vm.tiposPresupuestosList = this.$store.getters['tiposPresupuestos/selectList'];
          vm.inicializandoTiposPresupuestos = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar el listado de tipos de presupuesto.'));
      
      vm.inicializandoPrioridades = true;
      vm.$store.dispatch('prioridades/getList')
        .then(() => {
          vm.prioridades = this.$store.getters['prioridades/list'];
          vm.prioridadesList = this.$store.getters['prioridades/selectList'];
          vm.inicializandoPrioridades = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar el listado de prioridades.'));
      
      vm.inicializandoMonedas = true;
      vm.$store.dispatch('monedas/getList')
        .then(() => {
          vm.monedas = this.$store.getters['monedas/list'];
          vm.monedasList = this.$store.getters['monedas/selectList'];
          vm.inicializandoMonedas = false;
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar el listado de monedas.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'monedaCotizacion' || validarTodos) {
        if (this.$v.monedaCotizacion.$error) {
          this.monedaCotizacionValida = false;
          if (!this.$v.monedaCotizacion.decimal) {
            this.monedaCotizacionInvalidaMsj = 'La cotización de la moneda debe ser un valor numérico';
          } else {
            if (!this.$v.monedaCotizacion.maxValue) {
              this.monedaCotizacionInvalidaMsj = 'La cotización de la moneda ingresada no es válida';
            }      
          }     
        } else {
          this.monedaCotizacionValida = null;
          this.monedaCotizacionInvalidaMsj = '';
        }
      }

      if (campo == 'feeAgencia' || validarTodos) {
        if (this.$v.feeAgencia.$error) {
          this.feeAgenciaValido = false;
          if (!this.$v.feeAgencia.decimal) {
            this.feeAgenciaInvalidoMsj = 'El fee de agencia debe ser un valor numérico';
          } else {
            if (!this.$v.feeAgencia.maxValue || !this.$v.feeAgencia.minValue) {
              this.feeAgenciaInvalidoMsj = 'El fee de agencia ingresado no es válido';
            }      
          }     
        } else {
          this.feeAgenciaValido = null;
          this.feeAgenciaInvalidoMsj = '';
        }
      }

      if (campo == 'feeAgenciaPremios' || validarTodos) {
        if (this.$v.feeAgenciaPremios.$error) {
          this.feeAgenciaPremiosValido = false;
          if (!this.$v.feeAgenciaPremios.decimal) {
            this.feeAgenciaPremiosInvalidoMsj = 'El fee de agencia de premios debe ser un valor numérico';
          } else {
            if (!this.$v.feeAgenciaPremios.maxValue || !this.$v.feeAgenciaPremios.minValue) {
              this.feeAgenciaPremiosInvalidoMsj = 'El fee de agencia de premios ingresado no es válido';
            }      
          }     
        } else {
          this.feeAgenciaPremiosValido = null;
          this.feeAgenciaPremiosInvalidoMsj = '';
        }
      }

      if (campo == 'pjeFinanciacion' || validarTodos) {
        if (this.$v.pjeFinanciacion.$error) {
          this.pjeFinanciacionValido = false;
          if (!this.$v.pjeFinanciacion.decimal) {
            this.pjeFinanciacionInvalidoMsj = 'El pje de financiacion debe ser un valor numérico';
          } else {
            if (!this.$v.pjeFinanciacion.maxValue || !this.$v.pjeFinanciacion.minValue) {
              this.pjeFinanciacionInvalidoMsj = 'El pje de financiacion ingresado no es válido';
            }      
          }     
        } else {
          this.pjeFinanciacionValido = null;
          this.pjeFinanciacionInvalidoMsj = '';
        }
      }

      if (campo == 'accion' || validarTodos) {
        if (this.$v.accion.$error) {
          this.accionValida = false;
          if (!this.$v.accion.required) {
            this.accionInvalidaMsj= 'Debe ingresar el nombre de la acción.';
          } else if (!this.$v.accion.maxLength) {
            this.accionInvalidaMsj = 'El nombre de la acción solo puede contener hasta 50 caracteres';
          }      
        } else {
          this.accionValida = null;
          this.accionInvalidaMsj = '';
        }
      }

      if (campo == 'numeroOrdenCompra' || validarTodos) {
        if (this.$v.numeroOrdenCompra.$error) {
          this.numeroOrdenCompraValida = false;
          if (!this.$v.numeroOrdenCompra.maxLength) {
            this.numeroOrdenCompraInvalidaMsj = 'El número de orden de compra solo puede contener hasta 150 caracteres';
          }      
        } else {
          this.numeroOrdenCompraValida = null;
          this.numeroOrdenCompraInvalidaMsj = '';
        }
      }

      if (campo == 'descripcionOrdenCompra' || validarTodos) {
        if (this.$v.descripcionOrdenCompra.$error) {
          this.descripcionOrdenCompraValida = false;
          if (!this.$v.descripcionOrdenCompra.maxLength) {
            this.descripcionOrdenCompraInvalidaMsj = 'La descripción de la PO sólo puede contener hasta 150 caracteres.';
          }
        } else {
          this.descripcionOrdenCompraValida = null;
          this.descripcionOrdenCompraInvalidaMsj = '';
        }
      }

      if (validarTodos)
        this.$refs.totales.displayErrores();
    },
    save () {
      if (!this.saving) {
        /* Antes de intentar registrar por primera vez, no validamos */
        this.noValidar = false;

        this.$v.$touch();

        let save = true;

        let errorCliente = true;
        if (this.cliente) {
          if (this.cliente.id) {
            if (this.cliente.id != 0) {
              errorCliente = false;
            }
          }
        }
        if (errorCliente) {
          this.clienteValido = false;
          this.clienteInvalidoMsj = 'Debe seleccionar el cliente correspondiente.';
          save = false;
        }

        let tipoPresupuesto;
        if (this.tipoPresupuestoNombre) {
          tipoPresupuesto = this.getSelected(this.tiposPresupuestos, this.tipoPresupuestoNombre);
        }
        this.$store.dispatch('presupuestointerno/setTipoPresupuesto', tipoPresupuesto);

        let errorTipoPresupuesto = true;
        if (this.tipoPresupuesto) {
          if (this.tipoPresupuesto.id) {
            if (this.tipoPresupuesto.id != 0) {
              errorTipoPresupuesto = false;
            }
          }
        }

        if (errorTipoPresupuesto) {
          this.tipoPresupuestoValido = false;
          this.tipoPresupuestoInvalidoMsj = 'Debe seleccionar el tipo de presupuesto correspondiente.';
          save = false;
        }

        let prioridad;
        if (this.prioridadNombre) {
          prioridad = this.getSelected(this.prioridades, this.prioridadNombre);
        }
        this.$store.dispatch('presupuestointerno/setPrioridad', prioridad);

        let errorPrioridad = true;
        if (this.prioridad) {
          if (this.prioridad.id) {
            if (this.prioridad.id != 0) {
              errorPrioridad = false;
            }
          }
        }
        if (errorPrioridad) {
          this.prioridadValida = false;
          this.prioridadInvalidaMsj = 'Debe seleccionar la prioridad correspondiente.';
          save = false;
        }

        let moneda;
        if (this.monedaNombre) {
          moneda = this.getSelected(this.monedas, this.monedaNombre);
        }
        this.$store.dispatch('presupuestointerno/setMoneda', moneda);

        let errorMoneda = true;
        if (this.moneda) {
          if (this.moneda.id) {
            if (this.moneda.id != 0) {
              errorMoneda = false;
            }
          }
        }
        if (errorMoneda) {
          this.monedaValida = false;
          this.monedaInvalidaMsj = 'Debe seleccionar la moneda correspondiente.';
          save = false;
        }

        if (save) {
          if (this.$v.$anyError) {
            this.displayErrores();
          } else {
            if (this.id == 0) {
              /* Validamos si agregamos un presupuesto con cliente + accion correspondientes a un brief existente */
              let params = {
                clienteId: this.clienteId,
                accion: this.accion
              }
              
              this.showSpinner();
              this.$store.dispatch('briefs/existsBriefByClienteAccion', params)
                .then(() => {
                  this.hideSpinner();
                  
                  let existBrief = (/true/i).test(this.$store.getters['briefs/existsBrief']);

                  if (existBrief) {
                    this.showModalConfirm('El cliente y la acción ingresados corresponden a un brief de diseño existente, si registra el presupuesto se asociará a ese brief. ¿Confirma registrar el nuevo presupuesto?', 
                      this.savePresupuesto, 'Si', null, 'No');
                  } else {
                    this.savePresupuesto();
                  }
                })
                .catch(error => this.showErrorMsj(error))
                .finally(() => this.hideSpinner());
            } else {
              this.savePresupuesto();
            }
          }
        }
      }
    },
    savePresupuesto() {
      this.saving = true;
      this.showSpinner();
      this.$store.dispatch('presupuestointerno/save', this.id)
        .then(() => {
          this.saved = true;
          this.showModalMsj('Los cambios se registraron con éxito', this.goList, this.goList, 'light');
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => {
          this.saving = false;
          this.hideSpinner();
        })
    },
    goBack() {
      this.cancelled = true;
      this.$router.push({ name: 'PresupuestosInternos' });
    },
    cancelar() {
      this.confirmSalirModalVisible = true;
      this.routeNext = {
        name: 'PresupuestosInternos',
        params: ''
      };
    },
    goList() {
      this.modalRegistroExitoso = false
      this.$router.push({ name: 'PresupuestosInternos' });
    },
    agregarOrden() {
      let params = {
        discriminarCategoriaServicio: this.discriminarCategoriaServicio,
        clienteId: this.clienteId
      }
      this.showSpinner();
      this.$store.dispatch('ordentrabajo/inicializar', params)
        .then(() => {
          this.altaOrden = true;
          this.$refs.ordenTrabajoModal.show()
        })
        .catch(error => this.showErrorMsj(error))
        .finally(() => {
          this.hideSpinner();
        });
    },
    editarOrden(ordenTrabajo) {
      this.$store.dispatch('presupuestointerno/selectOrden', ordenTrabajo)
        .then (() => {
          let params = {
            discriminarCategoriaServicio: this.discriminarCategoriaServicio,
            clienteId: this.clienteId,
            orden: ordenTrabajo
          }
          this.showSpinner();
          this.$store.dispatch('ordentrabajo/inicializar', params)
            .then(() => {
              this.altaOrden = false;
              this.$refs.ordenTrabajoModal.show();
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        });
    },
    updateOrdenes() {
      this.$refs.ordenTrabajoModal.hide();
    },
    closeOrden() {
      this.$refs.ordenTrabajoModal.hide();
    },

    editarDescuentoOrden(ordenTrabajo) {
      this.ordenTrabajoId = ordenTrabajo.id;
      this.paramsActualizacion = {
        label: 'Dto Orden',
        importe: ordenTrabajo.importeDescuento
      }
      this.$refs.edicionDescuentoOrdenModal.show();
    },
    actualizarDescuentoOrden(params) {
      /* Actualizamos la orden */
      this.$refs.edicionDescuentoOrdenModal.hide();

      let paramsActualizacion = {
        ordenTrabajoId: this.ordenTrabajoId,
        importeDescuento: params.importe
      }
      this.$store.dispatch('presupuestointerno/updateDescuentoOrden', paramsActualizacion)
        .catch(error => this.showErrorMsj(error));
    },
    closeActualizacionDescuentoOrden() {
      this.$refs.edicionDescuentoOrdenModal.hide();
    },

    consultarAlternativas(ordenTrabajo) {
      this.$store.dispatch('presupuestointerno/consultarAlternativas', ordenTrabajo)
        .catch(error => this.showErrorMsj(error));
    },
    closeAlternativas() {
      this.$store.dispatch('presupuestointerno/clearConsultaAlternativas')
      .catch(error => this.showErrorMsj(error));
    },
    agregarOrdenAlternativa(ordenTrabajo) {
      this.$store.dispatch('presupuestointerno/selectOrden', ordenTrabajo)
        .then (() => {
          let params = {
            ordenTrabajo,
          }
          this.showSpinner();
          this.$store.dispatch('ordenTrabajoAlternativa/inicializar', params)
            .then(() => {
              this.altaOrden = true;
              this.$refs.ordenTrabajoAlternativaModal.show()
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        });
    },
    closeOrdenAlternativa() {
      this.$refs.ordenTrabajoAlternativaModal.hide();
    },
    editarAlternativa(ordenTrabajoAlternativa) {
      this.$store.dispatch('presupuestointerno/selectOrdenAlternativa', ordenTrabajoAlternativa)
        .then (() => {
          let params = {
            ordenTrabajo: this.ordenTrabajoAlternativas,
            ordenTrabajoAlternativa
          }
          this.showSpinner();
          this.$store.dispatch('ordenTrabajoAlternativa/inicializar', params)
            .then(() => {
              this.altaOrden = false;
              this.$refs.ordenTrabajoAlternativaModal.show();
            })
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        });
    },
    seleccionarAlternativa(ordenTrabajoAlternativa) {
      this.showSpinner();
      this.$store.dispatch('presupuestointerno/seleccionarOrdenAlternativa', ordenTrabajoAlternativa)
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    seleccionarCliente() {
      if (this.cliente) {
        this.$store.dispatch('presupuestointerno/setCliente', null)
        // this.clienteContactoNombre = null;
        // this.clientesContactos = [];
        // this.clientesContactosList = [];
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.$refs.searchClienteModal.hide();
        this.$store.dispatch('presupuestointerno/setCliente', cliente)
          .then (() => {
            // this.getContactos();
            this.clienteValido = null;
            this.clienteInvalidoMsj = '';
          })
          .catch(error => this.showErrorMsj(error));
    },

    seleccionarClienteContacto() {
      if (this.clienteContacto) {
        this.$store.dispatch('presupuestointerno/setClienteContacto', null)
      } else {
        this.$refs.searchClienteContactoModal.show();
      }
    },
    clienteContactoSeleccionado(clienteContacto) {
      this.$refs.searchClienteContactoModal.hide();
      this.$store.dispatch('presupuestointerno/setClienteContacto', clienteContacto)
        .then (() => {
          this.clienteContactoValido = null;
          this.clienteContactoInvalidoMsj = '';
        })
        .catch(error => this.showErrorMsj(error));
    },
    addContacto() {
      let addContacto = false;
      if (this.clienteId) {
        if (this.clienteId != 0) {
          addContacto = true;
        }
      }

      if (addContacto) {
        this.$refs.contactoModal.show();
      } else {
        this.showErrorMsj('Seleccione en primer término el cliente correspondiente');
      }      
    },
    updateContactos(clienteContacto) {
      this.$refs.contactoModal.hide()
      this.$store.dispatch('presupuestointerno/setClienteContacto', clienteContacto)
        .catch(error => this.showErrorMsj(error));
    },
    closeContacto() {
      this.$refs.contactoModal.hide()
    },

    tipoPresupuestoActualizado(tipoPresupuestoNombre) {
      if (!this.inicializandoTiposPresupuestos) {
        this.tipoPresupuestoNombre = tipoPresupuestoNombre;

        this.tipoPresupuestoValido = null;
        this.tipoPresupuestoInvalidoMsj = '';
      }
    },
    prioridadActualizada(prioridadNombre) {
      if (!this.inicializandoPrioridades) {
        this.prioridadNombre = prioridadNombre;

        this.prioridadValida = null;
        this.prioridadInvalidaMsj = '';
      }
    },
    monedaActualizada(monedaNombre) {
      if (!this.inicializandoMonedas) {
        this.monedaNombre = monedaNombre;

        if (this.monedaNombre) {
          let moneda = this.getSelected(this.monedas, this.monedaNombre);
          this.$store.dispatch('presupuestointerno/setMoneda', moneda)
            .catch(error => this.showErrorMsj(error))

          this.monedaValida = null;
          this.monedaInvalidaMsj = '';
        }
      }
    },
    addFechaFacturacion() {
      this.facturacionSeleccionada = null;
      this.$refs.facturacionModal.show();
    },
    closePresupuestoFacturacion() {
      this.$refs.facturacionModal.hide();
    },
    removeFechaFacturacion(facturacion) {
      this.$store.dispatch('presupuestointerno/removeFechaFacturacion', facturacion.id)
        .catch(error => this.showErrorMsj(error));
    },
    editFechaFacturacion(facturacion) {
      this.facturacionSeleccionada = facturacion;
      this.$refs.facturacionModal.show();
    },
    agregarComision() {
      if (this.accesoComisiones) {
        this.vendedorComision = null;
        this.$refs.vendedorComisionModal.show();
      }
    },
    editarComision(vendedorComision) {
      if (this.accesoComisiones) {
        console.log(vendedorComision);
        this.vendedorComision = vendedorComision;
        this.$refs.vendedorComisionModal.show();
      }
    },
    borrarComision(vendedorComision) {
      this.$store.dispatch('presupuestointerno/deleteVendedorComision', vendedorComision.id)
        .catch(error => this.showErrorMsj(error));
    },
    // setVendedorComision() {
    //   if (this.accesoComisiones) {
    //     this.$refs.vendedorComisionModal.show();
    //   }
    // },
    closeVendedorComision() {
      this.$refs.vendedorComisionModal.hide();
    },
    consultarEscalasFee() {
      this.$refs.escalasFeeModal.show();
    },
    consultarEscalasFinanciacion() {
      this.$refs.escalasFinanciacionModal.show();
    },
    cancelarBeforeLeave(to) {
      /* Guardamos el parametro */
      this.routeNext = to;

      this.confirmSalirModalVisible = true;
    },
    leave() {
      this.cancelled = true;
      this.$router.push({ name: this.routeNext.name, 
                          params: this.routeNext.params});
    },    
    cancelarSalir() {
      this.confirmSalirModalVisible = false;
    },
    guardarSalir() {
      this.confirmSalirModalVisible = false;
      this.save();
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name.trim().toLowerCase() == 'login' ||
        to.name.trim().toLowerCase() == 'ordentrabajoabm') {
      next();
    } else {
      if (!this.saved && !this.cancelled) {
        this.cancelarBeforeLeave(to);
        /* Cancelamos hasta que confirme el usuario */
        next(false);
      } else {
        next();
      }
    }
  },  
  validations: {
    accion: {
      required,
      maxLength: maxLength(50)
    },
    numeroOrdenCompra: {
      maxLength: maxLength(150)
    },
    descripcionOrdenCompra: {
      maxLength: maxLength(150)
    },
    monedaCotizacion: {
      decimal,
      minValue: minValue(0),
    },
    feeAgencia: {
      decimal,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
    feeAgenciaPremios: {
      decimal,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
    pjeFinanciacion: {
      decimal,
      minValue: minValue(0),
      maxValue: maxValue(999)
    },
  },  
  watch: {
    'monedaCotizacion' : function(newVal, oldVal) {
      if ( newVal != oldVal && !this.loading) {
        this.$store.dispatch('presupuestointerno/calcularTotales')
          .catch(error => this.showErrorMsj(error))
      }
    },
    'feeAgencia' : function(newVal, oldVal) {
      if ( newVal != oldVal && !this.loading) {
        this.$store.dispatch('presupuestointerno/calcularTotales')
          .catch(error => this.showErrorMsj(error))

        /* Actualizamos el pje de comisión si corresponde */
        this.$store.dispatch('presupuestointerno/updatePjeComision')
          .catch(error => this.showErrorMsj(error))
      }
    },
    'feeAgenciaPremios' : function(newVal, oldVal) {
      if ( newVal != oldVal && !this.loading) {
        this.$store.dispatch('presupuestointerno/calcularTotales')
          .catch(error => this.showErrorMsj(error))
      }
    },
    'pjeFinanciacion' : function(newVal, oldVal) {
      if ( newVal != oldVal && !this.loading) {
        this.$store.dispatch('presupuestointerno/calcularTotales')
          .catch(error => this.showErrorMsj(error))
      }
    },
    'fechaOrdenCompraHabilitada' : function(newVal, oldVal) {
      this.fechaOrdenCompraDisabled = !(/true/i).test(this.fechaOrdenCompraHabilitada);
    }
  }    
}
</script>

<style>
  .custom-select {
    margin-bottom: 0 !important;
  }

  .presupuestos-internos .form-group {
    margin-bottom: 10px;
  }
  .presupuestos-internos div.card {
    margin-bottom: 15px;
  }

  div.presupuesto-header .card-body,
  div.presupuesto-totales .card-body {
    padding: 0;
  }
  div.presupuesto-header .card-body > div,
  div.presupuesto-totales .card-body > div {
    padding: 20px;
    /*padding-top: 15px;*/
  }
</style>
